import { useAssignToAgencyTeamMemberFormContext } from 'modals/ShiftModal/src/views/AssignToAgencyTeamMemberView/contexts/AssignToAgencyTeamMemberView.form.context';
import { fetchAgencyJaneQueryConfig } from 'modals/ShiftModal/src/views/AssignToAgencyTeamMemberView/contexts/context.constants';
import { useGQLQuery } from 'hooks';
import { UseGQLQuery } from 'hooks/useGQLQuery/useGQLQuery.types';
import { FC, useContext, useEffect } from 'react';
import {
  AssignToAgencyTeamMemberFetchAgencyJaneByIdQuery,
  AssignToAgencyTeamMemberFetchAgencyJaneByIdQueryVariables,
} from 'types/graphql';
import { createGQLDataContext } from 'utils/createDataContext';

export const FetchAgencyTeamMemberByIdDataContext = createGQLDataContext<
  UseGQLQuery<AssignToAgencyTeamMemberFetchAgencyJaneByIdQuery>
>({} as UseGQLQuery<AssignToAgencyTeamMemberFetchAgencyJaneByIdQuery>);

export const FetchAgencyTeamMemberByIdDataProvider: FC = ({ children }) => {
  const { onChange, values } = useAssignToAgencyTeamMemberFormContext();
  const { fetch, ...rest } = useGQLQuery<
    AssignToAgencyTeamMemberFetchAgencyJaneByIdQuery,
    AssignToAgencyTeamMemberFetchAgencyJaneByIdQuery,
    AssignToAgencyTeamMemberFetchAgencyJaneByIdQueryVariables
  >(
    fetchAgencyJaneQueryConfig({
      janeId: values.janeId,
      onSuccess: (data: AssignToAgencyTeamMemberFetchAgencyJaneByIdQuery) =>
        onChange({ target: { name: 'janeRelayId', value: data.fetchJane.relayId } }),
    }),
  );

  useEffect(() => {
    if (!!values.janeId) fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FetchAgencyTeamMemberByIdDataContext.Provider value={rest}>
      {children}
    </FetchAgencyTeamMemberByIdDataContext.Provider>
  );
};

export const useFetchAgencyTeamMemberByIdDataContext =
  (): UseGQLQuery<AssignToAgencyTeamMemberFetchAgencyJaneByIdQuery> =>
    useContext(FetchAgencyTeamMemberByIdDataContext);
